import { pipe } from 'ramda';
import { setAction, setLabel } from '@creditas-lab/analytics-events';
import { DispatchEvent, dispatchFrontendDashboardEvent } from './commons';

const dispatchAddEmailEvent: DispatchEvent = pipe(
  setAction('add_email'),
  dispatchFrontendDashboardEvent,
);

const dispatchAddEmailOpenEvent: DispatchEvent = pipe(setLabel('open'), dispatchAddEmailEvent);

const dispatchAddEmailCloseEvent: DispatchEvent = pipe(setLabel('close'), dispatchAddEmailEvent);

const dispatchAddEmailGoBackEvent: DispatchEvent = pipe(setLabel('back'), dispatchAddEmailEvent);

const dispatchAddEmailNextStepEvent: DispatchEvent = pipe(
  setLabel('next_step'),
  dispatchAddEmailEvent,
);

const dispatchAddEmailExistingEmailEvent: DispatchEvent = pipe(
  setLabel('existing_email'),
  dispatchAddEmailEvent,
);

const dispatchAddEmailResendCodeEvent: DispatchEvent = pipe(
  setLabel('resend_code'),
  dispatchAddEmailEvent,
);

const dispatchAddEmailValidCodeEvent: DispatchEvent = pipe(
  setLabel('valid_code'),
  dispatchAddEmailEvent,
);

const dispatchAddEmailInvalidCodeEvent: DispatchEvent = pipe(
  setLabel('invalid_code'),
  dispatchAddEmailEvent,
);

const dispatchAddEmailRedirectEvent: DispatchEvent = pipe(
  setLabel('redirect_atwotk'),
  dispatchAddEmailEvent,
);

const dispatchAddEmailGoToAddPhoneEvent: DispatchEvent = pipe(
  setLabel('navigate_add_phone'),
  dispatchAddEmailEvent,
);

export {
  dispatchAddEmailOpenEvent,
  dispatchAddEmailCloseEvent,
  dispatchAddEmailGoBackEvent,
  dispatchAddEmailNextStepEvent,
  dispatchAddEmailExistingEmailEvent,
  dispatchAddEmailResendCodeEvent,
  dispatchAddEmailValidCodeEvent,
  dispatchAddEmailInvalidCodeEvent,
  dispatchAddEmailRedirectEvent,
  dispatchAddEmailGoToAddPhoneEvent,
};
